import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { Content } from 'core/layouts';
import { BaasicFormControls, BaasicButton, BaasicFieldDropdown } from 'core/components';
import { toDate } from 'core/utils';

function FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModalTemplate({ facilityOrderTemplateNewFlowUSIntakeTemplateActivationModalStore, t }) {
	const {
		contentLoading,
		form,
		modalParams,
		patient,
		facilityOrderPatient,
		eligibilityStatusStore,
		eligibilityStatus,
		facilityOrderTemplate
	} = facilityOrderTemplateNewFlowUSIntakeTemplateActivationModalStore;

	return (
		<Content loading={contentLoading}>
			<div className="modal__header">
				<h3 className='modal__header__title'>{facilityOrderTemplate ? "Activate template" : "Activate patient"}</h3>
			</div>
			<div className="modal__body">
				<div className="u-flex--default u-flex--gap--2 u-mar--bottom--sml">
					<div className='type--color--primary type--wgt--semibold'>
						{patient && patient.lastName && `${patient.lastName}`}
						{patient && patient.lastName && patient.firstName && ', '}
						{patient && patient.firstName && `${patient.firstName}`}
					</div>

					<div className="u-flex--default u-flex--gap--2">
						<i className="u-icon u-icon--xsml u-icon--calendar"></i>
						<div className="card--tertiary__header__divider"></div>
						<div className="type--sml">{patient && toDate(patient.dateOfBirth)}</div>
						<div className="card--tertiary__header__divider"></div>
						<i className="u-icon u-icon--xsml u-icon--user"></i>
						<div className="type--sml">{patient && patient.ssn}</div>
					</div>
				</div>

				<div className="card--tertiary__data u-mar--bottom--tny u-flex--align-start">
					<div>
						<div className="card--tertiary__data__item">
							<div>Primary:</div>
							<div className="type--color--primary type--wgt--semibold">{patient && patient.primaryInsurance}</div>
							{patient && patient.primaryPolicyNo &&
								<div className="status--grey">{patient.primaryPolicyNo}</div>
							}
						</div>
						
							{patient && patient.primaryInsurance !== "Medicare" && patient.inactiveMedicareNo &&
								<div className="card--tertiary__data__item">
									<div>Inactive:</div>
									<div className="type--color--primary type--wgt--semibold">Medicare</div>
									{patient.inactiveMedicareNo &&
										<div className="status--grey">{patient.inactiveMedicareNo}</div>
									}
								</div>
							}
							<div>
							<div className="card--tertiary__data__item">
								<div>Insurance Info:</div>
								<div className="type--color--primary type--wgt--semibold">{facilityOrderPatient.insuranceInfo}</div>
							</div>
						</div>
						
					</div>

					<div>
						<div className="card--tertiary__data__item">
							<div>Secondary:</div>
							<div className="type--color--primary type--wgt--semibold">{patient && patient.secondaryInsurance}</div>
							{patient && patient.secondaryPolicyNo &&
								<div className="status--grey">{patient.secondaryPolicyNo}</div>
							}
						</div>
						{patient && !patient.secondaryInsurance.includes("Medicaid") && patient.inactiveMedicaidNo &&
							<div className="card--tertiary__data__item">
								<div>Inactive:</div>
								<div className="type--color--primary type--wgt--semibold">Medicaid</div>
								{patient.inactiveMedicaidNo &&
									<div className="status--grey">{patient.inactiveMedicaidNo}</div>
								}
							</div>
						}
					</div>
				</div>

				<div className="card--tertiary__data u-mar--bottom--med">
					<div>
						<div className="card--tertiary__data__item">
							<div>Initial Eligibility Status:</div>
							{facilityOrderPatient.facilityOrderPatientInitial && facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatus &&
								<div className="type--color--primary type--wgt--semibold">{facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatus.name}</div>
							}
						</div>
					</div>
				</div>

				<div >
					<div className="form__group">
						<BaasicFieldDropdown field={form.$('eligibilityStatusId')} store={eligibilityStatusStore} />
					</div>
				</div>
				{eligibilityStatus &&
					<div className="u-flex--default u-mar--bottom--sml">
						<label className="type--sml type--color--opaque u-mar--right--tny">After activation, the {facilityOrderTemplate ? "template" : "patient's templates"} will be shown on the Intake Reviewed tab on the US Intake page, and on the {eligibilityStatus == "Eligible" ? "In Progress" : "Reviewed-Clinical"} tab on the Clinical Review page.</label>
					</div>
				}
			</div>
			<div className='modal__footer is-right'>
				<BaasicButton
					className='btn btn--med btn--light'
					label={t('EDIT_FORM_LAYOUT.CANCEL')}
					onClick={() => modalParams.close()}
				/>
				<BaasicFormControls
					form={form}
					className='btn btn--med btn--primary'
					onSubmit={form.onSubmit}
					disabled={form.submitting || form.validating}
					label={t('EDIT_FORM_LAYOUT.ACTIVATE')}
				/>
			</div>
		</Content >
	)
}

FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModalTemplate.propTypes = {
	facilityOrderTemplateNewFlowUSIntakeTemplateActivationModalStore: PropTypes.object,
	t: PropTypes.func
};

export default defaultTemplate(FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModalTemplate);
